import type { PaletteGroupDef } from '@gitbook/react-uikit';
import { Icon } from '@gitbook/spine-icons';
import { filterOutNullable } from '@gitbook/util-ts';

import type { FeatureUpgradeAction, SiteCapability, SiteStructureContent } from '../../../state';

/** Returns upgrade and cleanup commands for site items whose plan excludes sections. */
export function getRestrictedSiteItemPaletteGroups(props: {
    item: SiteStructureContent;
    upgrade: FeatureUpgradeAction;
    deleteSiteItems: (items: SiteStructureContent[]) => void;
    sitePermissions: Pick<SiteCapability, 'canEditSite' | 'canCreateSite' | 'canAdminSite'>;
}): PaletteGroupDef[] {
    const { item, upgrade, deleteSiteItems, sitePermissions } = props;
    const canRemove =
        item.object === 'site-external-link'
            ? sitePermissions.canAdminSite
            : sitePermissions.canCreateSite;

    return [
        sitePermissions.canEditSite
            ? {
                  key: 'upgrade',
                  commands: [
                      {
                          key: 'upgrade-sections',
                          title: upgrade.label,
                          icon: Icon.Upgrade,
                          upgrade: true,
                          trigger: upgrade.onPress,
                      },
                  ],
              }
            : null,
        {
            key: 'cleanup',
            commands: [
                canRemove
                    ? {
                          key: `${item.object}.delete`,
                          title: 'Remove',
                          icon: Icon.Trashcan,
                          kind: 'danger' as const,
                          trigger: () => deleteSiteItems([item]),
                      }
                    : null,
            ].filter(filterOutNullable),
        },
    ].filter(filterOutNullable);
}
